export default __webpack_public_path__ + "static/hips-girl-35947c2723102fe1b9460930f5597965.png";